import React from 'react'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import CardUI from '../../../widgets/layout/CardUI.js'
import FeesNavUI from '../../../components/superUser/loanList/FeesNavUI'

const ProcFeePageUI = ({ context, errorList, response, accountFeeList, onRefreshClick }) =>
  <SuperUserHomePageUI context={context} className='pg_su_proc_fees' topnav='accounts'
    headerText='Processing Fees' centered={!accountFeeList || !errorList} page='fees'
  >
    {
      (!errorList || !accountFeeList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountFeeList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Processing Fees</b></span>
            </span>
          }
          right={<span />}
        />

        <FeesNavUI page='fees' />

        <ProcSummaryUI context={context} response={response} />

        <ProcFeesUI context={context} accountFeeList={accountFeeList} />

      </div>
    }
  </SuperUserHomePageUI>

const ProcSummaryUI = ({ context, response }) =>
  <CardUI title='Summary'>
    <div className='g_flex_h'>
      <ProcSummary2UI
        loanTotals={response.loanTotals}
        leaseTotals={response.leaseTotals}
        invDiscTotals={response.invDiscTotals}
        grandTotals={response.grandTotals}
      />
    </div>
 </CardUI>

const ProcSummary2UI = ({ loanTotals, leaseTotals, invDiscTotals, grandTotals }) =>
    <table className='g_table_2'>
      <tbody>
        <tr>
          <td></td>
          <td className='g_text_right'><b>Loan & Interest-only</b></td>
          <td className='g_text_right'><b className='g_m_left_100'>Lease</b></td>
          <td className='g_text_right'><b className='g_m_left_100'>Receivable financing</b></td>
          <td className='g_text_right'><b className='g_m_left_100'>Total</b></td>
        </tr>
        <tr>
          <td><div className='g_m_top_100' /></td>
        </tr>
        <tr>
          <td>Disbursed</td>
          <td className='g_text_right'>{loanTotals.disbursedF4}</td>
          <td className='g_text_right'><span className='g_m_left_100'>{leaseTotals.disbursedF4}</span></td>
          <td className='g_text_right'>{invDiscTotals.disbursedF4}</td>
          <td className='g_text_right'><span className='g_m_left_100'>{grandTotals.disbursedF4}</span></td>
        </tr>
        <tr>
          <td>Fees accrued (includes waived)</td>
          <td className='g_text_right'>{loanTotals.accruedF4}</td>
          <td className='g_text_right'>{leaseTotals.accruedF4}</td>
          <td className='g_text_right'>{invDiscTotals.accruedF4}</td>
          <td className='g_text_right'>{grandTotals.accruedF4}</td>
        </tr>
        <tr>
          <td>Accrued to disbursed percent</td>
          <td className='g_text_right'>{loanTotals.accruedToDisbursedPercent}%</td>
          <td className='g_text_right'>{leaseTotals.accruedToDisbursedPercent}%</td>
          <td className='g_text_right'>{invDiscTotals.accruedToDisbursedPercent}%</td>
          <td className='g_text_right'>{grandTotals.accruedToDisbursedPercent}%</td>
        </tr>
        <tr>
          <td><div className='g_m_top_100' /></td>
        </tr>
        <tr>
          <td>Total paid</td>
          <td className='g_text_right'>{loanTotals.totalPaidF4}</td>
          <td className='g_text_right'>{leaseTotals.totalPaidF4}</td>
          <td className='g_text_right'>{invDiscTotals.totalPaidF4}</td>
          <td className='g_text_right'>{grandTotals.totalPaidF4}</td>
        </tr>
        <tr>
          <td>Total pending</td>
          <td className='g_text_right'>{loanTotals.totalPendingF4}</td>
          <td className='g_text_right'>{leaseTotals.totalPendingF4}</td>
          <td className='g_text_right'>{invDiscTotals.totalPendingF4}</td>
          <td className='g_text_right'>{grandTotals.totalPendingF4}</td>
        </tr>
        <tr>
          <td>Total waived</td>
          <td className='g_text_right'>{loanTotals.totalWaivedF4}</td>
          <td className='g_text_right'>{leaseTotals.totalWaivedF4}</td>
          <td className='g_text_right'>{invDiscTotals.totalWaivedF4}</td>
          <td className='g_text_right'>{grandTotals.totalWaivedF4}</td>
        </tr>
        <tr>
          <td>Total unpaid</td>
          <td className='g_text_right'>{loanTotals.totalUnpaidF4}</td>
          <td className='g_text_right'>{leaseTotals.totalUnpaidF4}</td>
          <td className='g_text_right'>{invDiscTotals.totalUnpaidF4}</td>
          <td className='g_text_right'>{grandTotals.totalUnpaidF4}</td>
        </tr>
      </tbody>
    </table>

const ProcFeesUI = ({ context, accountFeeList }) =>
  <>
    {
      accountFeeList.map((acc, i) =>
        <CardUI key={i} title={(i + 1) + '. ' + acc.accountName} className='g_m_top_100' noUnderline={true} >
          <LRTableBodyUI>
            {
              acc.loanFeeList.map((loan, j) =>
                <LRTableRowUI key={j}
                  left={
                    <div className='g_flex_v'>
                      <span>
                        {loan.loanName}
                        <span className='g_muted g_m_left_100'>{loan.loanId}</span>
                      </span>
                      <span>
                        {loan.disbursementAmountF1}
                        <span className='g_muted g_m_left_100'>{loan.disbursementDateF1}</span>
                      </span>
                    </div>
                  }
                  right={
                    <table>
                      <tbody>
                        {
                          loan.procFee1F1 &&
                          <tr>
                            <td className='g_text_right' style={{ verticalAlign: 'top' }}>
                              {loan.procFee1F1}
                              {
                                loan.procFee1TDSF1 &&
                                <span className='g_small'>
                                  <br />TDS: {loan.procFee1TDSF1}
                                </span>
                              }
                            </td>
                            <td className='g_text_right'>
                              <BadgeUI label={loan.procFee1Status} className='g_m_left_100' /><br />
                              <span className='g_small g_muted'>{loan.procFee1Date}</span>
                            </td>
                          </tr>
                        }
                        <tr>
                          <td className='g_text_right' style={{ verticalAlign: 'top' }}>
                            {loan.procFee2F1}
                            {
                              loan.procFee2TDSF1 &&
                              <span className='g_small'>
                                <br />TDS: {loan.procFee2TDSF1}
                              </span>
                            }
                          </td>
                          <td className='g_text_right'>
                            <BadgeUI label={loan.procFee2Status} className='g_m_left_100' /><br />
                            <span className='g_small g_muted'>{loan.procFee2Date}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  }
                />
              )
            }
          </LRTableBodyUI>
        </CardUI>
      )
    }
  </>


export default ProcFeePageUI
